import type { Session } from "./types";

export function createBrowserStorage(key: string) {
	return {
		read(): Session | null {
			try {
				const raw = localStorage.getItem(key);
				return raw ? (JSON.parse(raw) as Session) : null;
			} catch {
				return null;
			}
		},
		write(session: Session): void {
			localStorage.setItem(key, JSON.stringify(session));
		},
		clear(): void {
			localStorage.removeItem(key);
		},
	};
}
